import * as React from 'react'
import { Link } from 'react-router-dom'

import parse, { type DOMNode, Element, domToReact } from 'html-react-parser'

interface Props {
  html: string
}

const MENTION_LINK_CLASSES = ['link_mentioned', 'mention'] as const

const HTMLWithMentions = ({ html }: Props) => {
  function parseWithLinks(html: string) {
    const options = {
      replace: (domNode: DOMNode) => {
        if (domNode instanceof Element && domNode.name === 'a' && domNode.attribs) {
          const href = domNode.attribs.href
          const classList = domNode.attribs.class?.trim().split(/\s+/).filter(Boolean) ?? []
          const isMentionLink = MENTION_LINK_CLASSES.some((cls) => classList.includes(cls))
          if (href && isMentionLink) {
            return (
              <span onClick={(e) => e.stopPropagation()}>
                <Link to={href}>{domToReact(domNode.children)}</Link>
              </span>
            )
          }
        }
      },
    }

    return parse(html, options)
  }

  return <div>{parseWithLinks(html)}</div>
}

export default HTMLWithMentions
